"use client"

// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025 Collab Digital Twins

import { DropdownMenuItem } from '@radix-ui/react-dropdown-menu'
import * as LR from 'lucide-react'
import { useTranslations } from 'next-intl'
import * as React from "react";
import { toast } from 'sonner'

import { useMenusContext } from '../../../../store'

// Shadcn components
import { AddItemDialog } from '../../../ui/AddItemDialog'
import { Button } from '../../../ui/Button'

// Icons

// Custom components
import GeocoderInput from './GeocoderInput'


interface AddBuildingProps {
  newBuildingFields: any
  setNewBuildingFields: (fields: any) => void
  open: boolean
  onOpenChange: (open: boolean) => void
  geocodeEarthApiKey?: string
  geocoderUrl?: string
}

export default function AddBuilding({
  newBuildingFields,
  setNewBuildingFields,
  open,
  onOpenChange,
  geocodeEarthApiKey,
  geocoderUrl,
}: AddBuildingProps) {
  // Translations
  const t = useTranslations('AddBuilding')

  const { setSelectedItem, setView } = useMenusContext()

  const handleGeocoderSelect = (fields) => {
    setNewBuildingFields(fields)
  }

  const handleGetStarted = () => {
    if (!newBuildingFields.buildingAddress?.trim()) {
      toast.error(t('toastErr'))
      return
    }

    const blankBuilding = {
      id: -1,
      ...newBuildingFields,
    }

    setSelectedItem(blankBuilding as any)
    setView('detail')
    onOpenChange(false)
  }

  return (
    <AddItemDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('title')}
      description={t('description')}
      icon={LR.Building2}
    >
      <div className="flex flex-col gap-2">
        <div className="text-sm font-medium text-foreground">{t('label')}</div>
        <GeocoderInput onSelect={handleGeocoderSelect} geocodeEarthApiKey={geocodeEarthApiKey} geocoderUrl={geocoderUrl} />
        {newBuildingFields.buildingAddress && (
          <div className="text-xs text-muted-foreground mt-1">
            {t('label2')}
            {' '}
            {newBuildingFields.buildingAddress}
          </div>
        )}
      </div>
      <div className="w-full flex justify-end">
        <Button
          variant="secondary"
          className="w-fit"
          onClick={handleGetStarted}
          disabled={!newBuildingFields.buildingAddress?.trim()}
        >
          {t('submit')}
        </Button>
      </div>
    </AddItemDialog>
  )
}